import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './styles/tailwind.css';
import reportWebVitals from './reportWebVitals';
import { initGA, trackNewVisitor } from './utils/analytics';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// Отложенная инициализация Google Analytics после первого рендера
setTimeout(() => {
  initGA();
  trackNewVisitor();
}, 0);

// Отслеживание производительности
reportWebVitals((metric) => {
  // Отправляем метрики производительности в GA
  if (window.gtag) {
    window.gtag('event', 'web_vitals', {
      event_category: 'performance',
      event_label: metric.name,
      value: Math.round(metric.value),
      non_interaction: true
    });
  }
}); 